import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import Tab from '../../../Components/Tab/Tab';
import './AutoSMS.scss';

/* **** 
    VisitTarget 참고
    **** */

const routeList = {
    '/auto-sms/first': '첫적립',
    '/auto-sms/birthday' : '생일',
    '/auto-sms/retention' : '재방문 유도',
    '/auto-sms/point' : '적립/결제',
}

const AutoSMS = () => {
    const [ name, setName ] = React.useState('first')

    const route = useSelector((state) => state.user.route)
    const navigate = useNavigate();
    
    const tabRoute = [
        { route : 'first', header : '첫적립' },
        { route : 'birthday', header : '생일' },
        { route : 'retention', header : '재방문 유도' },
        { route : 'point', header : '적립/결제' }
    ]

    return (
        <div className='target-sms'>
            <div className='header-row'>
                <p className='header-text'>문자 {'>'} 자동문자 설정 {'>'}</p>
                <p className='header'>{routeList[route]}</p>
            </div>

            <Tab 
                routes={tabRoute}
                current={route.replace('/auto-sms/','')}
                onTabChange={(name) => {setName(name);navigate(`/auto-sms/${name}`)}}
                renderItems={{
                    'first' : <Outlet />,
                    'birthday' : <Outlet/>,
                    'retention' : <Outlet/>,
                    'point' : <Outlet/>
                }}
            />
        </div>
    )
}

export default AutoSMS;